import { EDIT_LOCATION } from '../constants/action-types';
export const editLocation = ({ name, locationId }) => ({
    type: EDIT_LOCATION,
    payload: {
        name,
        locationId,
    },
});
